import React from "react";
import BiddingScreen from "../../../../../Components/ReverseAuction/Bidding/BiddingScreen";

const BiddingGenerator = ({ type }) => {
  return <BiddingScreen type={type} />;
};

export default BiddingGenerator;
